/** @format */

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import axios from "axios";
import { Box, Button } from "@mui/material";
import VendorProfileView from "./VendorProfileView";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingButton from "@mui/lab/LoadingButton";

export default function DeepLinkService() {
  const [loading, setLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const navigate = useNavigate();
  const [vendorData, setvendorData] = useState([]);
  const { secretCode } = useParams();
  async function getVendorData(secretCode) {
    setIsFetching(true);
    try {
      const vendorResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/v1/vendor/dlsrv/${secretCode}`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              localStorage.getItem("accessToken")
            )}`,
          },
        }
      );
      console.log(vendorResponse);
      setvendorData(vendorResponse.data);
      setIsFetching(false);
    } catch (err) {
      setIsFetching(false);
      console.log(err);
    }
  }

  async function approveVendorDetails() {
    setLoading(true)
    try {
      const approveResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/vendor/validate/${vendorData?.vendorId}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              localStorage.getItem("accessToken")
            )}`,
          },
        }
      );
      console.log(approveResponse);
      setLoading(false)
      navigate("/dashboard")
      toast.success('vendor has been approved in the system.', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        });
    } catch (err) {
      setLoading(false)
      toast.error(`${err.message}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        });
      console.log(err);
    }
  }

  useEffect(() => {
    getVendorData(secretCode);
  }, [secretCode]);
  return (
    <>
      {isFetching ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Button
              variant="contained"
              sx={{ mt: 3, bgcolor: "secondary.main" }}
              onClick={() => navigate("/dashboard")}
            >
              Back
            </Button>
            <LoadingButton
              variant="contained"
              loading={loading}
              loadingPosition="end"
              sx={{ mt: 3, bgcolor: "secondary.main" }}
              onClick={() => approveVendorDetails()}
              endIcon={<HowToRegIcon />}
            >
              approve
            </LoadingButton>
          </Box>
          <Box
            sx={{
              m: 4,
              display: "flex",
              flexDirection: "column",
              gap: 2,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <VendorProfileView vendorDetails={vendorData} />
          </Box>
          <ToastContainer />
        </>
      )}
    </>
  );
}
